<template>
  <div class="vg_wrapper">
    <el-tabs v-model="activeName" type="border-card">
      <el-tab-pane label="单据信息" name="first" :key="'first'">
        <childTab1/>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import PsinAddMain from "@/views/StockManagement/PsinManage/TabChild/PsinAddMain";

export default {
  name: "PsinAdd",
  components: {
    childTab1: PsinAddMain
  },
  data() {
    return {
      activeName: "first",
    }
  },
}
</script>

<style scoped>

</style>